import ReactGA from 'react-ga4'
import ReactPixel from 'react-facebook-pixel'

export const getRestaurantMap = (orderData: any[], restaurants: any[]) => {
	return orderData.reduce((acc, item) => {
		const restaurant = restaurants.find(r => r.id === item.restaurantId)
		if (restaurant) acc[item.restaurantId] = restaurant.name
		return acc
	}, {})
}

export enum AnalyticsEvent {
	AddToCart = 'add_to_cart',
	BeginCheckout = 'begin_checkout',
	Purchase = 'purchase',
	ViewMenu = 'view_menu',
	ViewItem = 'view_item',
	RemoveItem = 'remove_item',
}

export const MetaAnalyticsEvent = {
	[AnalyticsEvent.AddToCart]: 'AddToCart',
	[AnalyticsEvent.BeginCheckout]: 'InitiateCheckout',
	[AnalyticsEvent.Purchase]: 'Purchase',
}

// type MetaAddToCart = {
// 	content_ids: string[]
// 	content_type: string
// 	contents: string[]
// 	currency: string
// 	value: number
// }

// type MetaInitiateCheckout = {
// 	content_ids: string[]
// 	contents: string[]
// 	currency: string
// 	num_items: number
// 	value: number
// }

// type MetaPurchase = {
// 	content_ids: string[]
// 	content_type: string
// 	contents: string[]
// 	currency: string
// 	num_items: number
// 	value: number
// }

// type Ga4AddToCart = {
// 	currency: string
// 	value: number
// 	items: [
// 		{
// 			item_id: string
// 			item_name: string
// 			affiliation: string
// 			coupon: string
// 			discount: number
// 			index: number
// 			item_brand: string
// 			item_category: string
// 			item_category2: string
// 			item_category3: string
// 			item_category4: string
// 			item_category5: string
// 			item_list_id: string
// 			item_list_name: string
// 			item_variant: string
// 			location_id: string
// 			price: number
// 			quantity: number
// 		},
// 	]
// }

// type Ga4BeginCheckout = {
// 	currency: string
// 	value: number
// 	coupon: string
// 	items: [
// 		{
// 			item_id: string
// 			item_name: string
// 			affiliation: string
// 			coupon: string
// 			discount: number
// 			index: number
// 			item_brand: string
// 			item_category: string
// 			item_category2: string
// 			item_category3: string
// 			item_category4: string
// 			item_category5: string
// 			item_list_id: string
// 			item_list_name: string
// 			item_variant: string
// 			location_id: string
// 			price: number
// 			quantity: number
// 		},
// 	]
// }

// type Ga4Purchase = {
// 	transaction_id: string
// 	// Sum of (price * quantity) for all items.
// 	value: number
// 	tax: number
// 	shipping: number
// 	currency: string
// 	coupon: string
// 	items: {
// 		item_id: string
// 		item_name: string
// 		affiliation: string
// 		coupon: string
// 		discount: number
// 		index: number
// 		item_brand: string
// 		item_category: string
// 		item_list_id: string
// 		item_list_name: string
// 		item_variant: string
// 		location_id: string
// 		price: number
// 		quantity: number
// 	}[]
// }

const formatParamsToMetaEvent = (name: AnalyticsEvent, params: any) => {
	switch (name) {
		case AnalyticsEvent.AddToCart:
			return {
				content_ids: params.itemId || [],
				content_type: params.itemCategory || '',
				contents: params.itemName || [],
				currency: 'CAD',
				num_items: params.quantity || 0,
				value: params.price || 0,
			}
		case AnalyticsEvent.BeginCheckout:
			return {
				content_ids: params.cart.map(item => item.id) || [],
				contents: params.cart.map(item => item.name) || [],
				currency: 'CAD',
				num_items: params.cart.reduce((acc, item) => acc + item.qty, 0) || 0,
				value: params.cart.reduce((acc, item) => acc + item.amount * item.qty, 0) / 100 || 0,
			}
		case AnalyticsEvent.Purchase:
			return {
				content_ids: params.cart.map(item => item.id) || [],
				content_type: params.cart.map(item => item.menuItemCategory) || '',
				contents: params.cart.map(item => item.name) || [],
				currency: 'CAD',
				num_items: params.cart.reduce((acc, item) => acc + item.qty, 0) || 0,
				value: params.cart.reduce((acc, item) => acc + item.amount * item.qty, 0) / 100 || 0,
			}
		default:
			return params
	}
}

const formatParamsToGa4Event = (name: AnalyticsEvent, params: any) => {
	switch (name) {
		case AnalyticsEvent.AddToCart:
			return {
				currency: 'CAD',
				value: params.price || 0,
				items: [
					{
						item_id: params.itemId,
						item_name: params.itemName,
						quantity: params.quantity,
						price: params.price,
						location_id: params.itemLocationId,
						item_brand: params.itemBrand || 'N/A',
						item_category: params.itemCategory,
						item_list_id: params.itemListId,
						item_list_name: params.itemListName,
					},
				],
			}
		case AnalyticsEvent.BeginCheckout:
			return {
				currency: 'CAD',
				value: params.cart.reduce((acc, item) => acc + item.amount * item.qty, 0) / 100 || 0,
				items: params.cart.map(item => ({
					item_id: item.id,
					item_name: item.name,
					quantity: item.qty,
					price: item.amount / 100,
					location_id: item.rId,
					item_brand: params.restaurantData[item.rId],
					item_category: item.menuItemCategory,
				})),
			}
		case AnalyticsEvent.Purchase:
			return {
				transaction_id: params.orderId,
				coupon: params.couponCode,
				tax: params.tax,
				currency: 'CAD',
				value: params.cart.reduce((acc, item) => acc + item.amount * item.qty, 0) / 100 || 0,
				items: params.cart.map(item => ({
					item_id: item.id,
					item_name: item.name,
					quantity: item.qty,
					price: item.amount / 100,
					location_id: item.rId,
					item_brand: params.restaurantData[item.rId],
					item_category: item.menuItemCategory,
				})),
			}
		case AnalyticsEvent.ViewMenu:
			return {
				currency: 'CAD',
				value: undefined,
				items: [
					{
						location_id: params.restaurantId,
						item_brand: params.restaurantName,
					},
				],
			}
		case AnalyticsEvent.ViewItem:
			return {
				currency: 'CAD',
				value: params.itemPrice / 100,
				items: [
					{
						item_id: params.itemId,
						item_name: params.itemName,
						price: params.itemPrice,
						item_brand: params.itemBrand,
						location_id: params.itemLocationId,
					},
				],
			}
		default:
			return params
	}
}

export const captureEvent = async (name: AnalyticsEvent, params: any) => {
	if (ReactGA.isInitialized) {
		try {
			const ga4Params = formatParamsToGa4Event(name, params)
			ReactGA.event(name, ga4Params)
			console.log(`[helpers.analytics] Captured event for Google Analytics 4: ${name}.`, ga4Params)
		} catch (error) {
			console.error(
				`[helpers.analytics] Error capturing Google Analytics 4 event ${name}.`,
				error.message
			)
		}
	}

	try {
		const event = MetaAnalyticsEvent[name]
		if (!event) return

		const eventData = formatParamsToMetaEvent(name, params)
		ReactPixel.track(event, eventData)
		console.log(`[helpers.analytics] Captured event for Meta Pixel: ${event}.`, eventData)
	} catch (error) {
		// Swallow the error. Expecting an error if Meta Pixel is not initialized.
		console.error(`[helpers.analytics] Error capturing Meta Pixel event ${name}.`, error.message)
	}
}

// https://developers.facebook.com/docs/meta-pixel/reference#standard-events
const initializeMetaPixel = (metaPixelId: string) => {
	console.log(`[helpers.analytics] Initializing MetaPixel: ***${metaPixelId.slice(10)}.`)

	ReactPixel.init(metaPixelId, null, {
		autoConfig: true,
		debug: process.env.NODE_ENV !== 'production',
	})
	ReactPixel.pageView()
}

const initializeGoogleAnalytics = (googleAnalyticsId: string) => {
	console.log(
		`[helpers.analytics] Initializing GoogleAnalytics4: ***${googleAnalyticsId.slice(8)}.`
	)

	ReactGA.initialize(googleAnalyticsId, {
		testMode: process.env.NODE_ENV !== 'production',
	})
	// [
	// {
	// 	trackingId: googleAnalyticsId,
	// },
	// ]
	// )
}

export const initializeAnalytics = (metaPixelId: string, googleAnalyticsId: string) => {
	if (metaPixelId) initializeMetaPixel(metaPixelId)
	if (googleAnalyticsId) initializeGoogleAnalytics(googleAnalyticsId)
}
